<template>
 <div
    class="p-4 d-flex flex-column flex-sm-row justify-content-center align-content-center"
  >
    <div class="cf m-3 text-center">
        <strong v-html=info[lang]> </strong>
        <div class="justify-content-center align-content-center">
            <img
                class="cf-img my-1 p-5"
                src="@/assets/rules/no-food-2.jpeg"/>
        </div>
    </div>
  </div>
</template>

<script>
export default {
data() {
    return {
        info: {
            fr: `<strong class="cf-text">Il est strictement interdit d’introduire dans le parc boissons et aliments. Uniquement les aliments pour bébés sont autorisés.<br>L'entrée aux mineurs non accompagnés est aussi strictement interdite.</strong>`,
            en: `<strong class="cf-text">It is strictly forbidden to bring drinks and food in the park. Only baby food is allowed.<br>The entry of unaccompanied minors is also strictly forbidden.`,
            ar: '<strong class="cf-text">يُمنع منعا باتا إدخال المشروبات و المواد الغذائية إلى المنتزه و يسمح فقط بطعام الرضع <br>ويُمنع أيضًا دخول القاصرين غير المصحوبين بذويهم منعًا باتًا',
        },
    }
  },
  components: {
  },
  computed: {
    lang() {
      return this.$store.getters['lang/getCurrentLang'];
    },
  },
};
</script>

<style src="./VitrineRules.css"></style>